import React from "react"
import App from "./App"
import { ErrorBoundary } from "react-error-boundary"
import { ErrorPage, ErrorLog } from "./pages/Error/Error"

import { AppProvider } from "./state/ContextProvider"

const AppWrapper: React.FC = () => {
  return (
    <>
      <ErrorBoundary FallbackComponent={ErrorPage} onError={ErrorLog}>
        <AppProvider>
          <App />
        </AppProvider>
      </ErrorBoundary>
    </>
  )
}

export default AppWrapper
